export default __webpack_public_path__ + "static/media/WeatherReporting_01.ee20ab6e.png";